export const JOURNAL_ENTRIES_FETCH = 'JOURNAL_ENTRIES_FETCH';
export const JOURNAL_ENTRIES_FETCH_SUCCESS = 'JOURNAL_ENTRIES_FETCH_SUCCESS';
export const JOURNAL_ENTRIES_FETCH_ERROR = 'JOURNAL_ENTRIES_FETCH_ERROR';
export const journalEntriesFetch = (page = 1) => ({type: JOURNAL_ENTRIES_FETCH, page});

export const JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE = 'JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE';
export const journalEntriesUpdatePossiblePage = possiblePage => ({type: JOURNAL_ENTRIES_UPDATE_POSSIBLE_PAGE, possiblePage});

export const JOURNAL_ENTRY_CREATE = 'JOURNAL_ENTRY_CREATE';
export const JOURNAL_ENTRY_CREATE_SUCCESS = 'JOURNAL_ENTRY_CREATE_SUCCESS';
export const JOURNAL_ENTRY_CREATE_ERROR = 'JOURNAL_ENTRY_CREATE_ERROR';
export const journalEntryCreate = (emoji, text, successMessage = '') => ({type: JOURNAL_ENTRY_CREATE, emoji, text, successMessage});

export const JOURNAL_EMOJIS_FETCH = 'JOURNAL_EMOJIS_FETCH';
export const JOURNAL_EMOJIS_FETCH_SUCCESS = 'JOURNAL_EMOJIS_FETCH_SUCCESS';
export const JOURNAL_EMOJIS_FETCH_ERROR = 'JOURNAL_EMOJIS_FETCH_ERROR';
export const journalEmojisFetch = () => ({type: JOURNAL_EMOJIS_FETCH});

export const JOURNAL_CREATION_CHANGE = "JOURNAL_CREATION_CHANGE";
export const journalCreationChange = updates => ({type: JOURNAL_CREATION_CHANGE, updates});



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/actions.js
 **/